import { render, staticRenderFns } from "./MoveButton.vue?vue&type=template&id=59ad209b&scoped=true&"
import script from "./MoveButton.vue?vue&type=script&lang=js&"
export * from "./MoveButton.vue?vue&type=script&lang=js&"
import style0 from "./MoveButton.vue?vue&type=style&index=0&id=59ad209b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad209b",
  null
  
)

export default component.exports